<template>
  <div>
    <!-- 商品退货 -->
    <div class="content">
      <!-- 创建任务 -->
      <div class="storeType">
        <el-button type="success" @click="createTask">{{ $t('message.createTask') }}</el-button>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <!-- 任务类型 -->
        <el-form-item :label="$t('message.taskType') + ':'" prop="type">
          <el-select v-model="ruleForm.type" disabled>
            <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 执行人 -->
        <el-form-item :label="$t('message.executor') + ':'" prop="execute_by">
          <el-select v-model="ruleForm.execute_by" clearable filterable>
            <el-option v-for="item in adminList" :key="item.key" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 消息推送人 -->
        <el-form-item :label="$t('message.messageRecipient') + ':'">
          <el-select v-model="ruleForm.msg_receive" multiple clearable filterable>
            <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 任务截止时间 -->
        <el-form-item :label="$t('message.taskDeadline') + ':'" prop="end_at">
          <el-date-picker v-model="ruleForm.end_at" type="datetime" default-time="['20:00:00']"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <!-- 具体抽查要求：-->
        <el-form-item :label="$t('message.specificSpotCheckRequirements') + ':'" prop="desc">
          <div class="specificSpotCheckRequirements">
            <!-- 从系统选择抽查内容-->
            <el-button type="primary" @click="specificSpotCheckRequirements">{{
              $t('message.selectSpotCheckContentFromSystem') }}</el-button>
            <!-- 手动添加 -->
            <el-button type="primary" @click="manuallyAdd">{{ $t('message.manuallyAdd') }}</el-button>
            <div class="table">
              <ol>
                <li>NO</li>
                <!-- 具体要求 -->
                <li class="flex3">{{ $t('message.specificRequirements') }}</li>
                <!-- 操作 -->
                <li>{{ $t('message.operation') }}</li>
              </ol>
              <ul v-for="(item, index) in ruleForm.desc" :key="index">
                <li>{{ index + 1 }}</li>
                <!-- 具体要求 -->
                <li class="flex3">{{ item }}</li>
                <!-- 操作 -->
                <li>
                  <el-button type="primary" @click="ruleForm.desc.splice(index, 1)">
                    {{ $t('message.delete') }}
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <!-- *抽查项目选择： -->
        <el-form-item :label="$t('message.spotCheckItemSelection') + ':'" prop="spot_detail">
          <div class="spotCheckItemSelection">
            <!-- 从系统选择抽查内容-->
            <el-button type="primary" @click="spotCheckItemSelection">{{ $t('message.selectSpotCheckContentFromSystem')
            }}</el-button>
            <div class="table">
              <ol>
                <!-- 订单号 -->
                <li class="flex2">{{ $t('message.orderNumber') }}</li>
                <!-- 番号 -->
                <li>{{ $t('message.mash') }}</li>
                <!-- 店铺信息 -->
                <li>{{ $t('message.storeInformation') }}</li>
                <!-- 照片 -->
                <li>{{ $t('message.pic') }}</li>
                <!-- 业务编辑属性 -->
                <li class="flex2">{{ $t('message.businessEditAttributes') }}</li>
                <!-- 当前数据 -->
                <li class="flex2">{{ $t('message.currentData') }}</li>
                <!-- 退换货数量 -->
                <li>{{ $t('message.quantityOfReturnAndReplacement') }}</li>
                <!-- 操作 -->
                <li>{{ $t('message.operation') }}</li>
              </ol>
              <ul v-for="(item, index) in ruleForm.spot_detail" :key="index">
                <!-- 订单号 -->
                <li class="flex2">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                    {{ item.order_sn }}
                  </router-link>
                </li>
                <!-- 番号 -->
                <li>{{ item.sorting }}</li>
                <!-- 店铺信息 -->
                <li>
                  <div class="template">
                    <p>{{ item.shop_name }}</p>
                    <p style="color: #15ad3c">{{ item.from_platform }} ({{ (item.service_rate * 100).toFixed(1) }}%)</p>
                    <p>{{ item.shop_id }}</p>
                  </div>
                </li>
                <!-- 照片 -->
                <li> <el-image style="width: 60px; height: 60px" :src="item.pic" :preview-src-list="[item.pic]">
                  </el-image></li>
                <!-- 业务编辑属性 -->
                <li class="flex2">
                  <div class="attribute">
                    <el-tooltip placement="bottom" style="height:100px">
                      <div slot="content">
                        <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                          style="margin-bottom: 5px">
                          {{ itemDetail.key }}：{{ itemDetail.value }}
                        </div>
                      </div>
                      <div>
                        <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                          @click="copy(itemDetail.value)">
                          {{ itemDetail.key }}：{{ itemDetail.value }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </li>
                <!-- 当前数据 -->
                <li class="flex2">
                  <div class="template">
                    <p>
                      数量：{{ item.confirm_num }}
                    </p>
                    <p>单价：{{ item.confirm_price }}</p>
                    <p>国内运费：{{ item.confirm_freight }}</p>
                    <p>小计：{{ ((item.confirm_num * item.confirm_price) + (item.confirm_freight - 0)).toFixed(2) }}</p>
                  </div>
                </li>
                <!-- 退换货数量 -->
                <li>
                  {{ item.refund_num }}
                </li>
                <!-- 操作 -->
                <li>
                  <el-button type="primary" @click="ruleForm.spot_detail.splice(index, 1)"> {{ $t('message.delete')
                  }}</el-button>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 从系统选择抽查内容 -->
    <specificRequirementsSelection ref="specificRequirementsSelection" :typeName="typeName" :taskType="taskType" />
    <!-- 手动添加要求 -->
    <manuallyAddRequirements ref="manuallyAddRequirements" />
    <!--抽查项目选择  -->
    <spotDetailOptionType ref="spotDetailOptionType" :taskType="taskType" />
  </div>
</template>
<script>
import specificRequirementsSelection from '../specificRequirementsSelection'
import manuallyAddRequirements from '../manuallyAddRequirements'
import spotDetailOptionType from './spotDetailOptionType/productReturn'
import { lastFewDays } from '@/utlis/date'
export default {
  props: {
    taskType: { type: [Number, String] },
    options: { type: Array },
    adminList: { type: Array },
    executeTypeList: { type: Array },
  },
  components: {
    specificRequirementsSelection,
    manuallyAddRequirements,
    spotDetailOptionType
  },
  data() {
    return {
      typeName: '',// 类型名称
      rules: {
        type: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        end_at: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        execute_by: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "change",
        },],
        msg_receive: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        desc: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        spot_detail: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      },
      ruleForm: {
        type: this.taskType - 0,
        spot_sn: '',
        execute_by: '',
        end_at: lastFewDays(new (Date), 3),
        msg_receive: [],
        desc: [],
        spot_detail: [],

      },
    };
  },
  methods: {
    // 具体抽查要求 从系统选择抽查内容
    specificSpotCheckRequirements() {
      this.typeName = this.options.find(item => item.key == this.taskType).name
      this.$refs.specificRequirementsSelection.expectList()
    },
    //手动添加
    manuallyAdd() {
      this.$refs.manuallyAddRequirements.dialogVisible = true
      this.$refs.manuallyAddRequirements.content = ''
    },
    //加入任务
    addToTask(list) {
      list.forEach(item => {
        this.ruleForm.desc.push(item.desc)
      })
      this.ruleForm.desc = [...new Set(this.ruleForm.desc)];
      this.$refs.ruleForm.validate(valid => { })
      this.$forceUpdate()
    },
    //抽查项目选择：
    spotCheckItemSelection() {
      this.$refs.spotDetailOptionType.order_sn = ''
      this.$refs.spotDetailOptionType.tableData = []
      this.$refs.spotDetailOptionType.dialogVisible = true
    },
    // 加入抽查项目
    addSpotDetail(list) {
      list.forEach(item => {
        this.ruleForm.spot_detail.push(item)
      })
      var hash = {};
      this.ruleForm.spot_detail = this.ruleForm.spot_detail.reduce(function (item, next) {
        hash[next.refund_detail_id]
          ? ""
          : (hash[next.refund_detail_id] = true && item.push(next));
        return item;
      }, []);
      this.$refs.ruleForm.validate(valid => { })
      this.$forceUpdate()
    },
    // 创建任务
    createTask() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

          // 获取新单号
          this.$api.spotCheckApi.getNewSpotSn({ type: this.taskType }).then(res => {
            this.ruleForm.spot_sn = res.data.spot_sn
            // 新建任务
            this.$api.spotCheckApi.storeType10(this.ruleForm).then(res => {
              this.$message.success(res.msg)
              this.$parent.$parent.isCreate = false
              this.$parent.$parent.spotList()
            });
          });
        }
      })
    },
    // 不能输入负数
    handleInputPrice(index) {
      this.ruleForm.spot_detail[index].num = ("" + this.ruleForm.spot_detail[index].num) // 第一步：转成字符串
        .replace(/[^0-9]/g, '') // 第二步：把不是数字过滤
      if (this.ruleForm.spot_detail[index].num > this.ruleForm.spot_detail[index].confirm_num) {
        this.ruleForm.spot_detail[index].num = this.ruleForm.spot_detail[index].confirm_num
      }
      this.$forceUpdate()
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  position: relative;

  .storeType {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 9;
  }

  /deep/.el-form-item {
    margin-bottom: 30px;
  }

  .table {
    margin-top: 20px;

    ol {
      height: 50px;
    }

    ul {
      background-color: #fff;
      padding: 20px 0;
    }

    .flex3 {
      flex: 3;
    }

    .flex2 {
      flex: 2;
    }

  }

  .specificSpotCheckRequirements {
    .table {
      width: 772px;
    }
  }

}
</style>